
{
  "familyId": "SPR-TREMA-MV",
  "questions": [
    {
      "id": "SPR-TREMA-MV-001",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "multiple_choice",
      "question": "Wat is het correcte meervoud van 'bacterie'?",
      "options": ["bacteriën", "bacterien", "bacterie's", "bacterieën"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Trema bij meervoud", "content": "Als twee klinkers naast elkaar komen te staan in het meervoud, gebruik je een trema (¨) om te laten zien dat je ze apart uitspreekt.\n\nbacterie + ën = bacteriën\nDe ë laat zien: spreek de e apart uit van de i.", "icon": "book"}}
      ],
      "conceptId": "trema_meervoud_bacterien",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Het meervoud van 'bacterie' is 'bacteriën'. De trema (¨) op de e laat zien dat je de e apart uitspreekt: bacteri-ën, niet 'bacterien' (wat je als 'bacterien' zou lezen). Zonder trema smelten de klinkers samen.",
        "solutionSteps": [
          "Bacterie + en = bacteriën",
          "De i en e komen naast elkaar → trema nodig",
          "Trema op de ë: bacteriën",
          "Spreek uit: bacteri-ën (apart) ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Bacteriën — met trema op de ë.",
          "1": "Zonder trema lees je 'bacterien' als één klank. De trema scheidt de klinkers: bacteri-ën. Onthoud: trema = apart uitspreken.",
          "2": "Een apostrof (') gebruik je niet bij meervouden op -en. Het is bacteriën (met trema), niet bacterie's.",
          "3": "'Bacterieën' heeft een extra e. Het meervoud is bacterie + ën = bacteriën, niet bacterie + eën."
        }
      }
    },
    {
      "id": "SPR-TREMA-MV-002",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "multiple_choice",
      "question": "Wat is het correcte meervoud van 'idee'?",
      "options": ["ideeën", "ideeen", "idee's", "ideën"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Trema bij dubbele klinker", "content": "Bij 'idee' eindigt het woord op -ee. Het meervoud is -en.\nidee + en → ideeën\n\nDe trema laat zien: de laatste e hoort bij '-en', niet bij 'idee'. Zo lees je idee-ën, niet 'ideeen'.", "icon": "book"}}
      ],
      "conceptId": "trema_meervoud_ideeen",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het meervoud van 'idee' is 'ideeën'. Er komen drie e's naast elkaar (idee + en). De trema op de derde e laat zien waar het meervoud begint: idee-ën. Zonder trema zou je 'ideeen' als één lang woord lezen.",
        "solutionSteps": [
          "Idee + en = ideeën",
          "Drie e's naast elkaar → trema nodig",
          "Trema op de ë: ideeën",
          "Spreek uit: idee-ën (apart) ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Ideeën — met trema op de derde e.",
          "1": "Zonder trema lees je 'ideeen' als één klank. De trema scheidt het woord: idee-ën.",
          "2": "Een apostrof (') gebruik je bij meervouden op -s (idee's is ook correct!). Maar het standaard meervoud op -en is ideeën.",
          "3": "'Ideën' mist een e. Het woord 'idee' heeft twee e's: idee + ën = ideeën."
        }
      }
    },
    {
      "id": "SPR-TREMA-MV-003",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "multiple_choice",
      "question": "Bij welk woord is de trema CORRECT geplaatst?",
      "options": ["geïnteresseerd", "geinteresseerd", "ge-interesseerd", "geïntereseerd"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Trema na voorvoegsel", "content": "Na voorvoegsels zoals ge-, be-, ver- gebruik je een trema als het volgende deel met dezelfde klinker begint.\n\nge + interesseerd → geïnteresseerd\nDe ï laat zien: spreek ge- en in- apart uit.", "icon": "book"}}
      ],
      "conceptId": "trema_voorvoegsel",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Na het voorvoegsel 'ge-' begint 'interesseerd' met een i. Twee klinkers naast elkaar (e + i) → trema: geïnteresseerd. De trema laat zien dat je ge- en in- apart uitspreekt. Zonder trema zou je 'gein-' lezen.",
        "solutionSteps": [
          "Herken het voorvoegsel: ge- + interesseerd",
          "De e van ge- en de i van in- komen naast elkaar",
          "Trema op de ï: geïnteresseerd",
          "Spreek uit: ge-ïn-te-res-seerd ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Geïnteresseerd — trema op de ï na het voorvoegsel ge-.",
          "1": "Zonder trema lees je 'gein-teresseerd'. De trema scheidt de klinkers: ge-ïnteresseerd.",
          "2": "Een koppelteken (-) gebruik je niet na voorvoegsels. Gebruik een trema: geïnteresseerd, niet ge-interesseerd.",
          "3": "'Geïntereseerd' mist een s. Het woord is 'interesseerd' (met dubbele s): geïnteresseerd."
        }
      }
    },
    {
      "id": "SPR-TREMA-MV-004",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "multiple_choice",
      "question": "Welk woord heeft een trema nodig?",
      "options": ["zeeën", "boeken", "stoelen", "tafels"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Wanneer trema?", "content": "Een trema is nodig als twee klinkers naast elkaar komen en je ze apart moet uitspreken.\n\nzee + en → zeeën (drie e's → trema)\nboek + en → boeken (geen klinkerbotsing → geen trema)\n\nGeen trema nodig als de klinkers niet botsen.", "icon": "book"}}
      ],
      "conceptId": "trema_wanneer_nodig",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Alleen 'zeeën' heeft een trema nodig. Zee + en = zeeën — drie e's naast elkaar, dus de trema scheidt ze: zee-ën. Bij boeken, stoelen en tafels botsen er geen klinkers, dus is geen trema nodig.",
        "solutionSteps": [
          "Zeeën: zee + en → drie e's → trema nodig ✓",
          "Boeken: boek + en → geen klinkerbotsing",
          "Stoelen: stoel + en → geen klinkerbotsing",
          "Tafels: tafel + s → geen klinkerbotsing"
        ],
        "distractorExplanations": {
          "0": "Goed! Zeeën heeft een trema: zee + en → drie e's naast elkaar.",
          "1": "Boeken heeft geen trema nodig. Boek + en → de k en e botsen niet. Trema is alleen nodig bij klinker + klinker.",
          "2": "Stoelen heeft geen trema nodig. Stoel + en → de l en e botsen niet.",
          "3": "Tafels heeft geen trema nodig. Tafel + s → geen klinkerbotsing."
        }
      }
    },
    {
      "id": "SPR-TREMA-MV-005",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "fill_in",
      "question": "Schrijf het meervoud van 'kolonie'. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["koloniën", "kolonien"],
        "caseSensitive": false,
        "placeholder": "typ het meervoud"
      },
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Kolonie + ën", "content": "Kolonie eindigt op -ie. Het meervoud is -en.\nkolonie + en → koloniën\n\nDe trema laat zien: de e hoort bij -en, niet bij -ie. Spreek uit: koloni-ën.", "icon": "book"}}
      ],
      "conceptId": "trema_meervoud_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het meervoud van 'kolonie' is 'koloniën'. De i en e komen naast elkaar (kolonie + en), dus gebruik je een trema: koloni-ën. De trema laat zien dat je de klinkers apart uitspreekt.",
        "solutionSteps": [
          "Kolonie + en = koloniën",
          "De i en e botsen → trema nodig",
          "Trema op de ë: koloniën",
          "Spreek uit: koloni-ën ✓"
        ]
      }
    }
  ]
}
